import {UntypedFormControl, Validators} from '@angular/forms';
import {DateValidator} from '../validator/date-validator';
import {ValidatorRegex} from '../validator/validator-enum';

export const createSensorForm = {
  sensorType: new UntypedFormControl(null, [
    Validators.required,
  ]),
  sensorName: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(55),
  ]),
  device: new UntypedFormControl(null, [
    Validators.required,
  ]),
  instrumentType: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(255),
  ]),
  locationName: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(40),
  ]),
  locationX: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  locationY: new UntypedFormControl(null, [
    Validators.required,
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  locationZ: new UntypedFormControl(null, [
    Validators.maxLength(10),
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  startDate: new UntypedFormControl(null, [
    Validators.required,
    DateValidator.validate(),
  ]),
  endDate: new UntypedFormControl(null, [
    DateValidator.validate(),
  ]),
  measurementLocations: new UntypedFormControl(null, [
    Validators.required,
  ]),
};
